import React from "react";
import { useAuth } from "@/context/AuthContext";
import { DemandMapPanel } from "@/components/demand/DemandMapPanel";

export default function AdminDemandMap() {
  const { user } = useAuth();
  if (!["super_admin", "admin"].includes(user?.role) || user?.org_type !== "internal") {
    return <div className="p-8 label-mono" data-testid="demand-page-denied">Only Super Admins and Admins can open this page.</div>;
  }
  return (
    <div className="p-6 md:p-8" data-testid="demand-page">
      <div className="label-mono">Recruiting</div>
      <h1 className="font-chivo font-black text-4xl uppercase tracking-tighter mb-4">Demand map</h1>
      <div className="brut-card"><DemandMapPanel /></div>
    </div>
  );
}
